module.exports = __webpack_public_path__ + "static/media/icons8-facebook.a6a36fca.svg";